<template>
  <commonSelect
    ref="commonSelect"
    :value="value"
    @input="v=>$emit('input',v)"
    placeholder="请选择系统"
    :clearable="clearable"
    idKey="SystemId"
    labelKey="SystemName"
    @select="onSelect"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import api from "@/api/ba/system";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    params: {},
  },
  components: { commonSelect },
  data() {
    return { api };
  },
  methods: {
    onSelect(value) {
      this.$emit("select", value);
    },
    getDataFunc() {
      var params = { Pid: 0 };
      if (this.params != null) params = this.params;
      return new Promise((resolve, reject) => {
        this.api.list(params).then((res) => {
          // console.log(res.Data);
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

